import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { AgeRange, IProfileState } from ".";

export interface ISetAgeRangeResponse {
    ageRange: AgeRange;
};

export const setAgeRange = createAsyncThunk<ISetAgeRangeResponse, number>(
    'setAgeRange',
    async (ageRange: AgeRange) => await api.profiles.setAgeRange(ageRange)
);

export const setAgeRangeHandler = (builder: ActionReducerMapBuilder<IProfileState>) => {    
    builder
        .addCase(setAgeRange.pending, (state: IProfileState) => {
            state.loading = true;
            state.error = "";
        })
        .addCase(setAgeRange.fulfilled, (state: IProfileState, action: PayloadAction<ISetAgeRangeResponse>) => {
            state.loading = false;
            state.ageRange = action.payload?.ageRange;
        })
        .addCase(setAgeRange.rejected, (state: IProfileState) => {
            state.loading = false;
            state.error = 'Unable to set age range';
        });
};

export default setAgeRangeHandler;